// extracted by mini-css-extract-plugin
export default {"achievement":"Achievement_achievement__YDwPH","complete":"Achievement_complete__M1RTV"};